import { render, staticRenderFns } from "./FormHorizontal.vue?vue&type=template&id=5036a8d8"
import script from "./FormHorizontal.vue?vue&type=script&lang=js"
export * from "./FormHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports